import * as types from "./types";

export const createExamRequest = (payload) => ({
  type: types.CREATE_REQUEST_EXAM_REQUEST,
  payload,
});

/**
 * Charge la liste plate des demandes d'examens d'un patient.
 *
 * @param {number} patientId
 */
export const getExamRequestsByPatient = (patientId) => ({
  type: types.GET_REQUEST_EXAMS_REQUEST,
  payload: { patientId },
});
